import { render, staticRenderFns } from "./UserSettingsView.vue?vue&type=template&id=5363ab16"
import script from "./UserSettingsView.vue?vue&type=script&lang=js"
export * from "./UserSettingsView.vue?vue&type=script&lang=js"
import style0 from "./UserSettingsView.vue?vue&type=style&index=0&id=5363ab16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports